import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const StyledRadiobuttonContainer = styled.div<{
  disabled?: boolean;
}>`
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 20px;
  width: 20px;
  cursor: ${(prop) => (prop.disabled ? "not-allowed" : "pointer")};
  position: relative;
  pointer-events: ${(props) => (props.disabled ? "none" : "all")};
  box-sizing: border-box;
`;

const StyledRadiobutton = styled.input`
  appearance: none;
  background-color: ${theme.colors.white};
  margin: 0;
  font: inherit;
  width: 20px;
  height: 20px;
  cursor: pointer;
  border: 2px solid ${theme.colors.purple};
  border-radius: 100%;

  & + div {
    display: none;
  }

  &:disabled {
    pointer-events: none;
    border: 2px solid ${theme.colors.grey_4};
    cursor: default;
  }

  &:checked + div {
    display: block;
  }

  &:focus {
    outline-offset: 0;
    --tw-ring-offset-width: 0px;
    --tw-ring-color: none;
  }
`;

const StyledCheckmark = styled.div<{
  $disabled?: boolean;
}>`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  left: 50%;
  top: 50%;
  background-color: ${(prop) =>
    prop.$disabled ? theme.colors.grey_4 : theme.colors.purple};
  transform: translate(-50%, -50%);
  display: none;
  box-sizing: border-box;
`;

export { StyledRadiobuttonContainer, StyledRadiobutton, StyledCheckmark };
